import './assets/index.css'
import { fetchMemberDetail, fetchConfig } from './views/customerService'
import im from './views/im'

document.documentElement.style.backgroundColor = '#333'

function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search)
  return params.get(name)
}

const sesskey = getQueryParam('sesskey')
const userid = getQueryParam('userid')

Promise.all([
  fetchMemberDetail({ sesskey, userid }),
  fetchConfig()
]).then(([userInfoRes, configRes]) => {
  const userInfo = userInfoRes?.data ?? {}
  const config = configRes?.data ?? {}
  const app = window.layui.config({
    layimPath: `${import.meta.env.BASE_URL}layim/`,
    layimAssetsPath: `${import.meta.env.BASE_URL}layim/layim-assets/`,
    version: '20220119'
  }).extend({
    layim: `${import.meta.env.BASE_URL}layim/layim`
  }).use(['layim'], (layim) => {
    layim.cache().mine = {
      id: Number(userInfo.mid),
      username: userInfo.username,
      nick: userInfo.nick,
      avatar: userInfo.avatar
    }
    layim.cache().socketUrl = config.socketUrl
    layim.cache().uploadImageUrl = config.uploadImageUrl
    layim.cache().sesskey = userInfo.sesskey
    im.install(app)
  })
})
